import { get, startCase, replace } from 'lodash';

const getNoteVariant = (category) => (category === 'message' ? 'message' : 'regular');

const getNoteType = (note) => {
  const stateChange = get(note, 'details.context', null);
  const isUpdate = get(note, 'details.type') === 'update';

  if (note.category === 'interaction') return 'Interaction';
  if (note.category === 'service_provided') return 'Service Provided';
  if (stateChange) return startCase(replace(stateChange, /_/g, ' '));
  if (isUpdate) return 'Updated';
  return 'Note';
};

const getServiceProvided = (details) => {
  const sp = get(details, 'service_provided', null);
  if (!sp) return null;

  const amount = get(sp, 'amount', '');
  const unit = get(sp, 'unit', '');

  return {
    date: get(sp, 'date', ''),
    type: get(sp, 'type', ''),
    amount,
    unit: unit === 'dollar' && amount > 1 ? `${unit}s` : unit,
  };
};

export const toNoteShape = (note, durations = [], reason = null) => {
  const interactionDate = get(note, 'interactionDate', {});
  const noteType = getNoteType(note);
  const durationValue = get(note, 'details.interaction.duration', '');
  const durationOption = durations.find((d) => Number(d.value) === durationValue);

  return {
    id: note.id,
    variant: getNoteVariant(note.category),
    text: note.text,
    noteType,
    date: {
      day: get(interactionDate, 'day', ''),
      month: get(interactionDate, 'month', ''),
      year: get(interactionDate, 'year', ''),
      time: get(interactionDate, 'time'),
    },
    metadata: {
      label: noteType,
      action: get(note, '_processedAdded') || null,
      employeeName: get(note, 'employee.full_name', ''),
      providerName: get(note, 'employee.provider.name') || undefined,
      date: get(note, '_processedDate', ''),
    },
    interactionType: get(note, 'interactionType', ''),
    interactionDate: get(note, 'details.interaction.date') || get(note, 'created_at', ''),
    duration: durationValue,
    durationLabel: durationOption ? durationOption.display_name : undefined,
    serviceProvided: getServiceProvided(note.details),
    isPrivate: get(note, 'visibility') === 'private',
    reason: reason || undefined,
    personName: get(note, 'person.full_name'),
    senderName: get(note, 'sender.full_name'),
  };
};

export const transformNotes = (notes, durations, reason) => notes.map((note) => toNoteShape(note, durations, reason));
